import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SettingsService } from '../../../shared/services/settings.service';
import { SettingsBaseComponent } from '../settings-base/settings-base.component';

@Component({
  selector: 'app-business-support-settings',
  templateUrl: './business-support-settings.component.html',
  styleUrls: ['./business-support-settings.component.scss']
})
export class BusinessSupportSettingsComponent extends SettingsBaseComponent implements OnInit {

  constructor(protected formBuilder: FormBuilder, protected settingsService: SettingsService, protected toastrService: ToastrService, protected translateService: TranslateService) {
    super(formBuilder, settingsService, toastrService, translateService);
  }

  ngOnInit() {
  }
}
